import React from "react";
import Dbm from "dbm";

export default class ElfsightAggregatedRating extends Dbm.react.BaseObject {
    _construct() {
        super._construct();

        let element = document.querySelector(".elfsight-app-22e563cd-f085-472e-8dae-b453127f2273");
        if(!element) {
            element = document.createElement("div");
            element.className = "elfsight-app-22e563cd-f085-472e-8dae-b453127f2273 overflow-hidden";
            element.setAttribute("data-elfsight-app-lazy", true);
        }
        this.item.setValue("element", element);

        let scriptLoader = Dbm.loading.loadScript("https://elfsightcdn.com/platform.js");
        //Dbm.flow.runWhenMatched(scriptLoader.item.properties.status, 1, Dbm.commands.callFunction(this._mapStatus.bind(this), [scriptLoader]));
    }

    componentDidMount() {
        //console.log("componentDidMount");
		
        let parentElement = this.item.holderElement;
        parentElement.appendChild(this.item.element);
    }

    componentDidUpdate() {
        //console.log("componentDidUpdate");
        let parentElement = this.item.holderElement;
        parentElement.appendChild(this.item.element);
    }

    _renderMainElement() {

		let returnElement = this._mainElement(<div>
			<div ref={this.createRef("holderElement")} />
		</div>);

        return returnElement;
    }
}